import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import TerminalService from "../../app/data/terminal-details/terminalService";
import { initialTerminalState } from "./TerminalDetailsState";
import { TerminalRequestModel } from "../../app/data/terminal-details/models";

const terminalService = TerminalService.getInstance();

export const terminalSlice = createSlice({
    name: "terminal",
    initialState: initialTerminalState,
    reducers: {
        loading: (state) => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = null;
        },
        setTerminalDetails: (state, { payload }) => {
            state.data = payload;
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = true;
            state.errorMessage = null;
        },
        error: (state, { payload }) => {
            state.isLoading = false;
            state.isError = true;
            state.isSuccess = false;
            state.errorMessage = payload;
        },
        resetTerminalDetails: (state) => {
            state.data = null;
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.errorMessage = null;
        }
    },
});

export const {
    loading,
    setTerminalDetails,
    error,
    resetTerminalDetails
} = terminalSlice.actions;

export const terminalDetailsSelector = (state: IState) => state.terminal;

export const createNewTerminal = (data: TerminalRequestModel, onSuccess?: () => void, onError?: (message: string | object) => void): AppThunk => async (dispatch) => {
    dispatch(loading());
    const response = await terminalService.addNewTerminal(data);
    if (response.ok()) {
        dispatch(setTerminalDetails(response.data));
        onSuccess?.();
    } else {
        dispatch(error(response.getError()));
        if (typeof response.getError() === "string" && response.getError() !== "") {
            onError?.(response.getError() || "Error! Please try again later...");
        } else {
            onError?.("Error! Please try again later...");
        }
        
    }
}

export const getTerminalSummaryByTerminalNumber = (terminalNumber: string, onSuccess?: () => void): AppThunk => async (dispatch) => {
    if (!terminalNumber) return
    dispatch(loading());
    const response = await terminalService.getTerminalSummaryByTerminalNumber(terminalNumber);
    if (response.ok()) {
        dispatch(setTerminalDetails(response.data));
        onSuccess?.();
    } else {
        dispatch(error(response?.getError()));
    }
};

// update terminal summary by terminal number
export const updateTerminalSummaryByTerminalNumber = (terminalNumber: string, data: TerminalRequestModel, onSuccess?: () => void): AppThunk => async (dispatch) => {
    if (!terminalNumber) return
    dispatch(loading());
    const response = await terminalService.updateTerminalSummaryByTerminalNumber(terminalNumber, data);
    if (response.ok()) {
        dispatch(setTerminalDetails(response.data));
        onSuccess?.();
    } else {
        dispatch(error(response.getError()));
    }
};

const terminalReducer = terminalSlice.reducer;
export default terminalReducer;
